import axios from 'axios'
import { ref } from 'vue'

export function useAnnouncements({
    onDeleted = () => {},
    onError = () => {},
}) {
    const deleting = ref(false)

    const deleteAnnouncement = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/announcements/${id}`)
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteAnnouncement,
    }
}
